import { makeAutoObservable, onBecomeObserved } from "mobx"

import { notify } from "@src/app/components/notify"
import { APIPagination, fiatWithdrawalsApi } from "@src/shared/api"
import { FiatWithdrawalResponse } from "@src/shared/api/generated"

export type FormData = {
  amount?: string
  bank_account_id?: string
}

export class WithdrawFiatStore {
  private _withdrawalsList?: FiatWithdrawalResponse[] = []
  addFormData = (data: FormData) => {
    this.formData = { ...data }
  }

  addOtp = (value: string[]) => {
    this.otp = value.join("")
  }

  cancelWithdrawal = async (id: string): Promise<any> => {
    try {
      this.isLoading = true

      const { data: result } = await fiatWithdrawalsApi.cancelFiatWithdrawal(id)

      if (result.success) {
        await this.loadWithdrawalsList()

        return result
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false

      this.withdrawalInfo = undefined
    }
  }

  createWithdrawal = async (): Promise<any> => {
    const { amount, bank_account_id } = this.formData

    try {
      this.isLoading = true

      const { data: result } = await fiatWithdrawalsApi.createFiatWithdrawal({
        amount,
        bank_account_id,
        id: crypto.randomUUID(),
        otp: this.otp,
      })

      if (result.success) {
        this.withdrawalInfo = result.data

        return result
      }
    } finally {
      this.isLoading = false
    }
  }

  formData: FormData = {}

  isLoading = false

  loadWithdrawalsList = async (offset = 0, order?: "asc" | "desc") => {
    try {
      this.isLoading = true

      const { data: result } = await fiatWithdrawalsApi.getListFiatWithdrawals(
        order,
        offset,
        this.pageSize,
      )

      if (result.success) {
        this._withdrawalsList = result.data?.data

        this.total = result.data?.pagination?.total
      } else {
        notify.error()
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false
    }
  }

  otp?: string

  pageSize = 25

  sendWithdrawal = async (id: string): Promise<any> => {
    try {
      this.isLoading = true

      const { data: result } = await fiatWithdrawalsApi.sendFiatWithdrawal(id)

      if (result.success) {
        await this.loadWithdrawalsList()

        return result
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false

      this.withdrawalInfo = undefined
    }
  }

  total?: APIPagination["total"]

  withdrawalInfo?: FiatWithdrawalResponse

  constructor() {
    makeAutoObservable(this)

    onBecomeObserved(this, "_withdrawalsList", this.loadWithdrawalsList)
  }

  get withdrawalsList() {
    return (
      this._withdrawalsList?.map((item) => ({ key: item.id, ...item })) || []
    )
  }
}
